import React, { Fragment } from 'react'

import Text from 'components/_new/typography/Text/Text'

import Price from 'components/text/Price/Price'

import messages from './messages'
import s from './Price.scss'


const CartOrderItemPrice = ({ price, discount, isLocked }) => (
  <div className={s.priceContainer}>
    {
      Boolean(discount) && (
        <Fragment>
          <Price key="initialPrice" value={price} isCents />
          <div key="savedPrice" className={s.savedPrice}>
            <Text message={messages.saved} tag="span" size="14-24" />: <Price value={discount} isCents />
          </div>
        </Fragment>
      )
    }
    {
      !discount && !isLocked && (
        price === 0 ? (
          <Text message={messages.free} size="14-24" uppercase color="brand" />
        ) : (
          <Price value={price} isCents />
        )
      )
    }
  </div>
)


export default React.memo(CartOrderItemPrice)
